import clsx from 'clsx';
import styles from './widget-error.module.scss';
import { useConfig } from 'providers/config/ConfigProvider';
import { Icon, ICONS_ENUM, Typography, Button } from '@sanlam-glacier/app-common/components';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import { useState } from 'react';

const WidgetError = ({
  onRefresh,
  isRefreshing = false
}: {
  onRefresh: () => Promise<unknown>;
  isRefreshing: boolean;
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const { theme } = useConfig();
  const { widgetError } = useGetBranding(theme);

  const handleClick = async () => {
    setIsDisabled(true);
    onRefresh();

    setTimeout(() => {
      setIsDisabled(false);
    }, 60000);
  };

  return (
    <div className={clsx(styles.error)}>
      <div className={clsx(styles.illustration)}>
        <img className={clsx(styles.illustration)} src={widgetError} alt='Error illustration' />
      </div>
      <div className={clsx(styles.somethingWentWrongText)}>
        <Typography
          variant={Typography.VARIANT.B2}
          weight={Typography.WEIGHT.NORMAL}
          color={Typography.COLOR.PRIMARY}
        >
          <Icon icon={ICONS_ENUM.ALERT_ERROR} className={clsx(styles.icon)} />
          Something went wrong
        </Typography>
        <Typography
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
          color={Typography.COLOR.TERTIARY}
          className={styles.text}
        >
          <span className={styles.text}>
            There was an error loading this content. Please try again later.
          </span>
        </Typography>
      </div>

      <Button
        id='reloadWidgetButton'
        onClick={handleClick}
        size={Button.SIZE.SMALL}
        variant={Button.VARIANT.SECONDARY}
        startIcon={<Icon icon={ICONS_ENUM.NAVIGATION_REFRESH} className={styles.refreshIcon} />}
        disabled={isDisabled || isRefreshing}
      >
        Reload
      </Button>
    </div>
  );
};

export default WidgetError;
